var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcomeSection"},[_c('Headline'),_c('Review'),_c('Features'),_c('Value'),_c('Documentation'),_c('Standards'),_c('Learning'),_c('Signup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }